import React from 'react';

import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

class TooltipSelect extends React.Component {
    static displayName = 'TooltipSelect';

    static propTypes = {
        onMouseEnter: PropTypes.func,
        onMouseLeave: PropTypes.func,
        getPosition: PropTypes.func,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        onMouseEnter: null,
        onMouseLeave: null,
        getPosition: null,
        onClick: null,
    };

    constructor() {
        super();
        this.selectedElement = React.createRef();
    }

    componentDidMount() {
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
    }

    onMouseEnter = () => {
        const {
            useTooltip,
            noHover,
        } = this.props;

        if (!noHover && useTooltip) {
            this.props.onMouseEnter(undefined, this.resize);
        }
    };

    onClick = (e) => {
        const {
            useModal,
            showModal,
            noModal,
        } = this.props;
        if (!useModal || showModal || noModal) {
            // don't care, or already open
            return;
        }
        this.props.onClick(e);
    }

    resize = () => this.props.getPosition(this.getElementBounding());

    getElementBounding = () => {
        const rect = ReactDOM.findDOMNode(
            this.selectedElement.current,
        ).getBoundingClientRect();
        return {
            left: rect.left,
            top: rect.top,
            height: rect.height,
            width: rect.width,
        };
    };

    render() {
        const { children, onMouseLeave, className } = this.props;
        return React.cloneElement(<span className={className}>{children}</span>, {
            ref: this.selectedElement,
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: onMouseLeave,
            onTouchEnd: this.onMouseEnter,
            onClick: this.onClick,
        });
    }
}

export default TooltipSelect;
